var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.447 41C8.459 41 1.669 35.243.27 27.224c-.799-4.524.2-9.047 2.596-12.749 2.396-3.7 6.19-6.168 10.584-7.196 4.394-.823 8.787.205 12.382 2.673 2.995 2.056 5.192 5.14 6.39 8.841 1.398-.616 2.996-1.028 4.594-1.028 2.995 0 5.791 1.234 7.988 3.496S48 26.4 48 29.485s-1.198 5.963-3.395 8.225C42.408 39.972 39.612 41 36.617 41h-20.17zm0-3.084h20.17c2.197 0 4.194-.823 5.791-2.468 1.598-1.645 2.397-3.7 2.397-5.963 0-2.261-.8-4.317-2.397-5.962-1.597-1.645-3.594-2.468-5.791-2.468-1.598 0-3.395.617-4.593 1.44-.4.205-.999.41-1.398.205-.4-.206-.799-.617-.999-1.234-.599-3.7-2.596-6.785-5.591-8.841-2.996-2.056-6.59-2.879-10.185-2.262C6.46 11.803 1.669 19 3.067 26.607c1.198 6.58 6.79 11.309 13.38 11.309z"}));
}

Cloud.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Cloud;

Cloud.default = Cloud;
